export const ImportTypes = {
  IMPORT_ROLLS:'rolls',
  IMPORT_SPOOLS:'spools',
  IMPORT_RESINS:'resins',
  IMPORT_SHIPMENTS: 'shipment',
  IMPORT_ASN_SHIPMENTS: 'asnshipment',
  IMPORT_WO:'wos',
  IMPORT_KITS:'kits',
  IMPORT_GROUPS:'groups',
  IMPORT_TOOLS:'tools',
  IMPORT_TAGS:'tags',
  IMPORT_KIT_TYPES:'kittypes',
  IMPORT_KIT_TYPE_PLY_TYPES:'kitTypesPlyTypes',
  IMPORT_TOOL_TYPES:'tooltypes',
  IMPORT_PART_TYPES:'parttypes',
  IMPORT_TOOL_GROUPS:'toolGroups',
  IMPORT_PROJECTS:'projects',
  IMPORT_MATERIAL_TYPES:'materialtypes',
  IMPORT_GROUP_TYPES:'grouptypes',
  IMPORT_OPERATION_SEQUENCE:'operationSequence',
  IMPORT_NESTS_MULTI_ROLLS:'reportedCutsAndKitsMultiRolls',
  IMPORT_NESTS_ANY_ROLLS:'reportedCutsAndKitsAnyRolls',
  IMPORT_NESTS:'reportedCutsAndKits',
  IMPORT_NESTS_WITH_ROLL: 'importCutPlanWithRoll',
  IMPORT_PLY_TYPES: 'plytypes',
  IMPORT_BAGS: 'bags',
  IMPORT_QPL_JSON:'qplJson',
  IMPORT_QPL_FOR_MATERIAL_TYPES_JSON:'qplForMaterialType',
};

export const ImportAcceptFileTypes = {
  CSV: '.csv',
  JSON: '.json',
};
